<template>
  <NovaRequisicaoBalcaoComponent
    :category="3"
    :title="'Requisição Balcão Uniformes NR10'"
  />
</template>

<script>
import NovaRequisicaoBalcaoComponent from "../components/NovaRequisicaoBalcaoComponent.vue";
export default {
  components: {
    NovaRequisicaoBalcaoComponent,
  },
};
</script>

<style></style>
